import React, { ReactNode } from 'react'

// Matches inline markdown patterns: **bold**, *italic*, __underline__, ~~strikethrough~~
// Order matters: longer delimiters (**) must come before shorter ones (*)
const INLINE_MARKDOWN_REGEX = /(\*\*(.+?)\*\*|\*(.+?)\*|__(.+?)__|~~(.+?)~~)/g

const TAGS: Record<string, keyof JSX.IntrinsicElements> = {
  '**': 'strong',
  '*': 'em',
  '__': 'u',
  '~~': 's',
}

export function parseInlineMarkdown(text: string): ReactNode {
  if (!text) return text

  const parts: ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  let keyIndex = 0

  while ((match = INLINE_MARKDOWN_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }

    // match groups: [2]=**, [3]=*, [4]=__, [5]=~~
    const content = match[2] || match[3] || match[4] || match[5]
    const delimiter = match[2] ? '**' : match[3] ? '*' : match[4] ? '__' : '~~'
    const Tag = TAGS[delimiter]
    parts.push(<Tag key={keyIndex++}>{content}</Tag>)

    lastIndex = match.index + match[0].length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  // Reset regex lastIndex for reuse
  INLINE_MARKDOWN_REGEX.lastIndex = 0

  return parts.length === 1 ? parts[0] : parts
}
